import React from 'react';
import PropTypes from 'prop-types';
import Notification from '~/components/Notification';
import {Button, Link} from '@customink/pigment-react';
import {metrics} from '~/vendor/metrics';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
export default function SwapIncompatibleProductsWarning({dismiss, ...props}) {
  const continueHandler = () => {
    metrics.fireEvent('product_tray', 'alert_click', 'replace_product');
    return props
      .swapProduct(props.notification.selectedProductData)
      .then(() => dismiss());
  };

  const cancel = () => {
    metrics.fireEvent('product_tray', 'alert_click', 'cancel');
    dismiss();
  };

  const close = () => {
    metrics.fireEvent('product_tray', 'alert_click', 'close');
    dismiss();
  };

  return (
    <Notification
      {...props}
      closeLink="#/productCatalog"
      dismiss={close}
      title="Heads up!">
      <p className="ndx-cta1">
        Replacing this product will remove all other products that have been
        added because these items cannot be decorated together.
      </p>
      <Button
        size="large"
        variant="secondary"
        className="notification-cta"
        onClick={continueHandler}>
        Replace Product
      </Button>
      <p className="ndx-cta1" style={{marginTop: '19px'}}>
        <Link href="#/productCatalog" onClick={cancel}>
          Cancel
        </Link>
      </p>
    </Notification>
  );
}

const propTypes = {
  dismiss: PropTypes.func,
  notification: PropTypes.shape({
    selectedProductData: PropTypes.object
  }),
  swapProduct: PropTypes.func
};

SwapIncompatibleProductsWarning.propTypes = propTypes;

SwapIncompatibleProductsWarning.displayName = 'SwapIncompatibleProductsWarning';
